import "./authLayout.scss";
import { Outlet, useLocation } from "react-router-dom";

type IProps = {};

export default function AuthLayout({}: IProps) {
  const { pathname } = useLocation();
  const isVisible = pathname === "/login" || pathname === "/join";
  return (
    <>
      <div className="auth-layout web">
        <Outlet />
        <div className={isVisible ? "text-center" : "hidden"}>
          <p className="text-blue-300">MUSEUM</p>
          <sub className="text-[10px] text-gray-400 ">
            Copyright © 2023 by UBCompany Inc. All right reserved.
          </sub>
        </div>
      </div>
      <div className="auth-layout mb">
        <Outlet />
        <div className={isVisible ? "text-center" : "hidden"}>
          <p className="text-blue-300">MUSEUM</p>
          <sub className="text-[10px] text-gray-400 ">
            Copyright © 2023 by UBCompany Inc. All right reserved.
          </sub>
        </div>
      </div>
    </>
  );
}
